var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafety360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2822B3DA-AC92-4593-9AF5-6CAAD06DF0E3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.4217333,0 C12.028,0 12.8309333,0 13.6956,0.273333333 C14.6396,0.616933333 15.3830667,1.3604 15.7266667,2.3044 C16,3.16893333 16,3.97213333 16,5.57826667 L16,10.4217333 C16,12.028 16,12.8309333 15.7266667,13.6956 C15.3830667,14.6396 14.6396,15.3830667 13.6956,15.7265333 C12.8309333,16 12.028,16 10.4217333,16 L5.57826667,16 C3.972,16 3.16893333,16 2.3044,15.7265333 C1.3604,15.3830667 0.616933333,14.6396 0.273333333,13.6956 C0,12.8309333 0,12.028 0,10.4217333 L0,5.57826667 C0,3.97213333 0,3.16893333 0.273333333,2.3044 C0.616933333,1.3604 1.3604,0.616933333 2.3044,0.273333333 C3.16893333,0 3.972,0 5.57826667,0 L10.4217333,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.34574298%",
    y1: "97.654257%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87B4FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACCCFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2574FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73A9FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB2525",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7373",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD025",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE373",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77719062,0.323219445 C0.743507989,0.561761592 0.00722854989,1.47565683 0.00722854989,2.53618836 L0.00722854989,4.68719828 C0.00722854989,6.4953684 0.754867139,8.22299183 2.07356117,9.46010651 L3.3509492,10.6590131 C4.01597579,11.2827337 5.05069107,11.2827337 5.71468501,10.6590131 L6.99207304,9.46010651 C8.31076707,8.22299183 9.05840566,6.4953684 9.05840566,4.68719828 L9.05840566,2.53618836 C9.05840566,1.47565683 8.32212622,0.561761592 7.28844359,0.322186795 C6.3714504,0.110493548 5.45239192,0.00413059994 4.53333343,0.00413059994 C3.61427495,0.00413059994 2.69521646,0.110493548 1.77719062,0.323219445",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-10",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-12",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-14",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-16",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-18",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-20",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-22",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-24",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-26",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-28",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-30",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-32",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-34",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-36",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-38",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-40",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-42",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-44",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-46",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-48",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-50",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-52",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-54",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-56",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-58",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-60",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-62",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-64",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-66",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-68",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-70",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-72",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-74",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-76",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-78",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-80",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-82",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-84",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-86",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-88",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-90",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-92",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-94",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-96",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-98",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-100",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-102",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-104",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-106",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-108",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-110",
    x: 0.00309794995,
    y: 0.00206529997,
    width: 10.7116783,
    height: 6.9456038
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TO-BE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overview---GMS",
    transform: "translate(-52.000000, -20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-button",
    transform: "translate(22.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(32.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF7D6",
    strokeWidth: 2,
    d: "M11.0268987,-0.999346139 C12.3849263,-0.994657423 13.1640596,-0.943468667 13.9970128,-0.680160405 C15.2594105,-0.221648308 16.2216483,0.740589504 16.6663554,1.96236922 C16.9786487,2.9470838 17,3.82101526 17,5.57826667 L17,5.57826667 L17,10.4217333 C17,12.1791079 16.9786585,13.0527395 16.6801604,13.9970128 C16.2216301,15.2594606 15.2593357,16.2217148 14.0375136,16.6662647 C13.0528378,16.9786397 12.1791778,17 10.4217333,17 L10.4217333,17 L5.57826667,17 C3.82079946,17 2.94698542,16.9786299 2.00281124,16.6799714 C0.740664268,16.2217148 -0.221630073,15.2594606 -0.666355417,14.0376308 C-0.943468667,13.1640596 -0.994657423,12.3849263 -0.999352099,11.0234461 L-0.999352099,11.0234461 L-0.999346138,4.97313514 C-0.994657356,3.61512779 -0.943458712,2.83578045 -0.680147045,2.00294491 C-0.221648308,0.740589504 0.740589504,-0.221648308 1.96236922,-0.666355417 C2.83578175,-0.943459123 3.61501892,-0.99465735 4.97654775,-0.999352099 L4.97654775,-0.999352099 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-4)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-5)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shield",
    transform: "translate(4.000000, 3.333333)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.56936498,6.25922482 C7.31743422,6.94200514 6.93642735,7.53568364 6.4367849,8.02359839 C5.86806351,8.57894737 5.12335526,9.02023742 4.22332666,9.33502574 C4.19379292,9.34532322 4.16297197,9.35376145 4.13200802,9.35998283 C4.09110411,9.36806351 4.04948513,9.37242563 4.00822369,9.37299771 L4.00014301,9.37299771 C3.95616419,9.37299771 3.91197082,9.36856406 3.86813501,9.35998283 C3.83717106,9.35376145 3.80677917,9.34532322 3.77738845,9.33524027 C2.87628719,9.02095251 2.13064932,8.579877 1.56135583,8.02452804 C1.06149886,7.53661327 0.680563497,6.94329234 0.428990279,6.26051202 C-0.0284611076,5.01909325 -0.00243134096,3.65153032 0.0185211716,2.55256007 L0.0188787185,2.53568364 C0.0230978307,2.44493708 0.0258152128,2.34961384 0.0273169428,2.24435068 C0.0349685309,1.72754578 0.445866709,1.2999857 0.96274314,1.27116705 C2.04040331,1.21102689 2.87407037,0.859553776 3.58638444,0.165260302 L3.59260584,0.159539478 C3.71088386,0.0510583432 3.85991132,-0.00214531808 4.00822369,5.00403842e-06 C4.15124428,0.00193078261 4.2936928,0.0550629199 4.40775173,0.159539478 L4.4138301,0.165260302 C5.12628719,0.859553776 5.95995423,1.21102689 7.03761443,1.27116705 C7.55449084,1.2999857 7.96538902,1.72754578 7.97304062,2.24435068 C7.97454233,2.35032895 7.97725972,2.44550916 7.98147883,2.53568364 L7.98169336,2.54283467 C8.00257437,3.64387872 8.02846111,5.01415905 7.56936498,6.25922482 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.56936498,6.25922482 C7.31743422,6.94200514 6.93642735,7.53568364 6.4367849,8.02359839 C5.86806351,8.57894737 5.12335526,9.02023742 4.22332666,9.33502574 C4.19379292,9.34532322 4.16297197,9.35376145 4.13200802,9.35998283 C4.09110411,9.36806351 4.04948513,9.37242563 4.00822369,9.37299771 L4.00014301,9.37299771 C3.95616419,9.37299771 3.85991132,-0.00214531808 4.00822369,7.22403702e-07 C4.15124428,0.00193078261 4.2936928,0.0550629199 4.40775173,0.159539478 L4.4138301,0.165260302 C5.12628719,0.859553776 5.95995423,1.21102689 7.03761443,1.27116705 C7.55449084,1.2999857 7.96538902,1.72754578 7.97304062,2.24435068 C7.97454233,2.35032895 7.97725972,2.44550916 7.98147883,2.53568364 L7.98169336,2.54283467 C8.00257437,3.64387872 8.02846111,5.01415905 7.56936498,6.25922482 Z",
    id: "Path",
    fill: "#F2F7FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo_Safety360",
    transform: "translate(3.466667, 2.400000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.05943831,2.53618836 C9.05943831,1.47565683 8.32315887,0.561761592 7.28947624,0.322186795 C5.45135927,-0.103264998 3.61427495,-0.103264998 1.77615797,0.322186795 C0.743507989,0.561761592 0.00722854989,1.47565683 0.00722854989,2.53618836 L0.00722854989,4.68719828 C0.00722854989,6.4953684 0.754867139,8.22299183 2.07356117,9.46010651 L3.3509492,10.6590131 C4.01597579,11.2827337 5.05069107,11.2827337 5.71468501,10.6590131 L6.99207304,9.46010651 C8.31076707,8.22299183 9.05840566,6.4953684 9.05840566,4.68719828 L9.05840566,2.53618836 L9.05943831,2.53618836 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.4,
    mask: "url(#mask-9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.826120, -2.653910)",
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64294613,4.65725143 L1.64294613,5.97388016 L1.44570998,6.17731221 L1.44467733,6.17834486 L1.44467733,6.94663645 L1.45293853,6.94663645 L1.45293853,6.18144281 L1.65017468,5.97697811 L1.65120733,5.97594546 L1.65120733,4.65415348 L0.850903587,3.86107829 L0.850903587,2.62293096 L0.849870937,2.62189831 C0.848838287,2.62086566 0.718724389,2.49075176 0.588610491,2.36270316 C0.376917244,2.15514052 0.330447995,2.11486717 0.318056195,2.10867127 L0.318056195,0.63611239 L0.583447241,0.376917244 L0.584479891,0.375884594 L0.584479891,0.101199698 L0.576218691,0.101199698 L0.576218691,0.372786644 L0.309794995,0.63198179 L0.308762345,0.63301444 L0.308762345,2.11176922 L0.312892945,2.11176922 L0.313925595,2.11176922 L0.315990895,2.11383452 C0.314958245,2.11486717 0.313925595,2.11486717 0.313925595,2.11486717 C0.333545945,2.12106307 0.64127564,2.42362951 0.843675037,2.62602891 L0.843675037,3.86417624 L1.64294613,4.65725143 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-15)",
    points: "1.25157178 0.114624148 1.25157178 0.989278685 0.67018984 1.60473808 0.67018984 2.18715267 1.23814733 2.74788161 1.23814733 4.77187558 0.813728188 5.17460907 0.813728188 5.81795001 0.782748688 5.81795001 0.782748688 5.16221727 1.20716783 4.75845113 1.20716783 2.76130606 0.63921034 2.20057712 0.63921034 1.59234628 1.22059228 0.976886885 1.22059228 0.114624148"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-17)",
    points: "1.77719062 1.14417618 1.77719062 2.03948372 1.77512532 2.04258167 1.46946093 2.32759306 1.46946093 3.97880039 1.45397118 3.97880039 1.45397118 2.32036451 1.45603648 2.31829922 1.76170087 2.03328782 1.76170087 1.15140473 1.37858773 0.781716038 1.37858773 0.121852698 1.39407748 0.121852698 1.39407748 0.775520138"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-19)",
    points: "2.37922556 2.57336376 2.37922556 3.80118459 2.36373581 3.80118459 2.36373581 2.57955966 2.01470012 2.19644652 2.01470012 0.891176937 1.70697042 0.596871691 1.70697042 0.114624148 1.72246017 0.114624148 1.72246017 0.590675791 2.03018987 0.884981037 2.03018987 2.19128327"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-21)",
    points: "2.64151866 6.60999255 2.95957486 6.9476691 3.0452848 6.9476691 2.70347766 6.58520895 2.70347766 4.83486723 1.58821568 3.68552779 1.58821568 3.17023545 2.10867127 2.60227796 2.10867127 0.129081248 2.04567962 0.129081248 2.04567962 2.57852701 1.52625668 3.1464845 1.52625668 3.71134404 2.64151866 4.85965083"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-23)",
    points: "4.70578598 6.9476691 4.69752478 6.9394079 4.69545948 6.9373426 2.32139716 6.9373426 1.86703117 6.48194395 1.86703117 5.36977992 2.78299171 4.46001528 2.78505701 4.45691733 2.78505701 2.45151106 2.31313597 1.99198182 2.31313597 0.113591498 2.29764622 0.113591498 2.29764622 1.99921037 2.76956726 2.45873961 2.76956726 4.45072143 1.85360672 5.36048607 1.85154142 5.36255137 1.85154142 6.48813985 2.31003802 6.9476691"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-25)",
    points: "3.81977229 4.54572523 3.81977229 6.20003051 3.75781329 6.20003051 3.75781329 4.57154148 3.1836599 4.00255134 3.1836599 1.86806382 2.48558851 1.17412303 2.48558851 0.123917998 2.54754751 0.123917998 2.54754751 1.14830678 3.2456189 1.84224757 3.2456189 3.97673509"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-27",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-26"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-27)",
    points: "2.29145032 6.6399394 2.60744121 6.9476691 2.65287781 6.9476691 2.32242981 6.6275476 2.32242981 4.77187558 1.76376617 4.21321194 1.76376617 3.4273653 2.95647691 2.25014432 2.96164016 2.24498107 2.96164016 1.72555812 2.71690211 1.46326503 2.71690211 0.129081248 2.68592261 0.129081248 2.68592261 1.47565683 2.92962801 1.73794992 2.92962801 2.23258927 1.73794992 3.40981025 1.73278667 3.4149735 1.73278667 4.22560374 2.29145032 4.78426738"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-29",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-29)",
    points: "3.30861055 6.9476691 3.33959005 6.9476691 3.33959005 6.52944585 2.87386491 6.05649216 2.87386491 5.21901302 3.41187555 4.68203503 3.41187555 1.69354597 3.0349583 1.30836753 3.0349583 0.0805466988 3.0039788 0.0805466988 3.0039788 1.32179198 3.38089605 1.70593777 3.38089605 4.66861058 2.84288541 5.20662122 2.84288541 6.06888396 3.30861055 6.5428703"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-31)",
    points: "3.85591504 1.64707673 3.85591504 3.01120735 3.84042529 3.01120735 3.84042529 1.65430528 3.28382695 1.12249053 3.28382695 0.0981017485 3.2993167 0.0981017485 3.2993167 1.11526198"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-33",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-33)",
    points: "4.84725903 2.85527721 5.20558857 3.2084435 5.20558857 5.83963566 4.75432053 6.28367516 4.75328788 6.28470781 4.75328788 6.9476691 4.76154908 6.9476691 4.76154908 6.28780576 5.21281712 5.84479891 5.21384977 5.84376626 5.21384977 3.20534555 4.85448758 2.85217926 4.85448758 1.36206533 4.10581634 0.699104039 4.10581634 0.0609263491 4.09858779 0.0609263491 4.09858779 0.702201989 4.84725903 1.36619593"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-35",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-34"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-35)",
    points: "4.65621878 5.71365236 4.03146554 6.33737295 4.03146554 6.9476691 4.04695529 6.9476691 4.04695529 6.3446015 4.67170853 5.71984826 4.67170853 4.34022788 3.97673509 3.68552779 3.97673509 1.44570998 4.76464703 0.66502659 4.76464703 0.0609263491 4.74915728 0.0609263491 4.74915728 0.65883069 3.96124534 1.43848143 3.96124534 3.69172369 4.65621878 4.34745643"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-37",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-37)",
    points: "4.30098719 0.520455592 4.30098719 2.91000766 4.29995454 2.91104031 3.61427495 3.61220965 3.61427495 4.91541393 3.6132423 4.91644658 3.1382233 5.34396367 3.1382233 5.82621121 3.13099475 5.82621121 3.13099475 5.34086572 3.1320274 5.33983307 3.6070464 4.91128333 3.6070464 3.6091117 3.60807905 3.60807905 4.29272599 2.90690971 4.29272599 0.522520892 3.87347009 0.0557630992 3.87863334 0.0505998492"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-39",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-39)",
    points: "3.4934549 6.9476691 3.4934549 5.70745646 4.92470778 4.25348529 4.92883838 4.24832204 4.92883838 3.18882315 5.15498872 3.0019135 5.15498872 1.04710708 4.99905857 0.836446487 4.99905857 0.0846772987 4.96807908 0.0846772987 4.96807908 0.846772987 5.12400922 1.05743358 5.12400922 2.9874564 4.89785888 3.17436605 4.89785888 4.23593024 3.466606 5.68990141 3.4624754 5.69506466 3.4624754 6.9476691"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-41",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-40"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-41)",
    points: "5.41211857 2.32862571 5.41211857 3.1113744 5.39662882 3.1113744 5.39662882 2.33378896 5.19422942 2.08492032 5.19422942 0.0846772987 5.20971917 0.0846772987 5.20971917 2.07872442"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-43",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-42"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-43)",
    points: "3.54405475 1.86290057 3.54405475 2.38748676 3.5430221 2.38851941 2.98229315 2.91000766 2.98229315 3.69791959 2.98126051 3.69895224 1.42299168 5.24999252 1.42299168 5.78697051 1.41473048 5.78697051 1.41473048 5.24689457 1.41576313 5.24586192 2.97506461 3.69482164 2.97506461 2.90690971 2.97609726 2.90587706 3.5368262 2.38438881 3.5368262 1.86290057"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-45",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-44"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-45)",
    points: "5.10851947 4.58806388 5.10851947 5.06927877 5.04656047 5.06927877 5.04656047 4.61388013 4.56224763 4.13886114 4.56224763 3.22599855 4.08619599 2.78918761 4.08619599 1.15863328 3.78982544 0.862262737 3.78982544 0.521488242 3.85281709 0.521488242 3.85281709 0.836446487 4.14918764 1.13281703 4.14918764 2.76233871 4.62420663 3.19914965 4.62420663 4.11201224"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-47",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.48331818,3.96124534 C1.51073753,3.96124534 1.53331818,3.98382599 1.53331818,4.01124534 C1.53331818,4.0386647 1.51073753,4.06124534 1.48331818,4.06124534 C1.45589882,4.06124534 1.43331818,4.0386647 1.43331818,4.01124534 C1.43331818,3.98382599 1.45589882,3.96124534 1.48331818,3.96124534",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-47)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-49",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-48"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.43684893,5.76735016 C1.46426828,5.76735016 1.48684893,5.78993081 1.48684893,5.81735016 C1.48684893,5.84476952 1.46426828,5.86735016 1.43684893,5.86735016 C1.40942957,5.86735016 1.38684893,5.84476952 1.38684893,5.81735016 C1.38684893,5.78993081 1.40781667,5.76735016 1.43684893,5.76735016",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-49)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-51",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07650732,5.05378902 C5.10645417,5.05378902 5.13020512,5.07753997 5.13020512,5.10748682 C5.13020512,5.13743367 5.10645417,5.16118462 5.07650732,5.16118462 C5.04656047,5.16118462 5.02280952,5.13743367 5.02280952,5.10748682 C5.02280952,5.07753997 5.04656047,5.05378902 5.07650732,5.05378902",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-51)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-53",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78672749,6.17421426 C3.81667434,6.17421426 3.84042529,6.19796521 3.84042529,6.22791206 C3.84042529,6.25785891 3.81667434,6.28160986 3.78672749,6.28160986 C3.75678064,6.28160986 3.73302969,6.25785891 3.73302969,6.22791206 C3.73302969,6.19796521 3.75678064,6.17421426 3.78672749,6.17421426",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-53)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-55",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1531132,5.82001531 C3.18053256,5.82001531 3.2031132,5.84259596 3.2031132,5.87001531 C3.2031132,5.89743467 3.18053256,5.92001531 3.1531132,5.92001531 C3.12569385,5.92001531 3.1031132,5.89743467 3.1031132,5.87001531 C3.1031132,5.84098305 3.12569385,5.82001531 3.1531132,5.82001531",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-55)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-57",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.38998486,3.79602134 C2.41740422,3.79602134 2.43998486,3.81860199 2.43998486,3.84602134 C2.43998486,3.8734407 2.41740422,3.89602134 2.38998486,3.89602134 C2.36256551,3.89602134 2.33998486,3.8734407 2.33998486,3.84602134 C2.33998486,3.81860199 2.36256551,3.79602134 2.38998486,3.79602134",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-57)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-59",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86460904,3.00501145 C3.8920284,3.00501145 3.91460904,3.0275921 3.91460904,3.05501145 C3.91460904,3.08243081 3.8920284,3.10501145 3.86460904,3.10501145 C3.83718969,3.10501145 3.81460904,3.08243081 3.81460904,3.05501145 C3.81460904,3.0275921 3.83557678,3.00501145 3.86460904,3.00501145",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-59)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-61",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-60"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42184522,3.10621115 C5.44926457,3.10621115 5.47184522,3.1287918 5.47184522,3.15621115 C5.47184522,3.18363051 5.44926457,3.20621115 5.42184522,3.20621115 C5.39442586,3.20621115 5.37184522,3.18363051 5.37184522,3.15621115 C5.37184522,3.1287918 5.39442586,3.10621115 5.42184522,3.10621115",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-61)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-63",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4101445,2.11176922 L10.4101445,0.63301444 L10.1437208,0.372786644 L10.1437208,0.101199698 L10.1354596,0.101199698 L10.1354596,0.375884594 L10.4018833,0.63611239 L10.4018833,2.10867127 C10.3894915,2.11589982 10.3419896,2.15617317 10.131329,2.36270316 C10.0012151,2.49075176 9.8711012,2.61983301 9.87006855,2.62189831 L9.8690359,2.62293096 L9.8690359,3.86107829 L9.06976481,4.65312083 L9.06873216,4.65415348 L9.06873216,5.97697811 L9.26700096,6.18247546 L9.26700096,6.9476691 L9.27526216,6.9476691 L9.27526216,6.17937751 L9.07699336,5.97388016 L9.07699336,4.65725143 L9.87626445,3.86520889 L9.8772971,3.86417624 L9.8772971,2.62602891 C10.0796965,2.42362951 10.3874262,2.12106307 10.4070465,2.11486717 C10.4070465,2.11486717 10.4060139,2.11486717 10.4049812,2.11383452 L10.4070465,2.11176922 L10.4101445,2.11176922 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-63)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-65",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-65)",
    points: "10.0796965 1.59234628 10.0796965 2.20057712 9.51173901 2.76130606 9.51173901 4.75845113 9.93615815 5.16221727 9.93615815 5.81795001 9.90517865 5.81795001 9.90517865 5.17460907 9.48075951 4.77187558 9.48075951 2.74788161 10.048717 2.18715267 10.048717 1.60473808 9.46733506 0.989278685 9.46733506 0.114624148 9.49831456 0.114624148 9.49831456 0.976886885"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-67",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-67)",
    points: "9.34031911 0.121852698 9.34031911 0.781716038 8.95720596 1.15140473 8.95720596 2.03328782 9.26493566 2.32036451 9.26493566 3.97880039 9.24944591 3.97880039 9.24944591 2.32759306 8.94171622 2.03948372 8.94171622 1.14417618 9.32482936 0.775520138 9.32482936 0.121852698"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-69",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-68"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-69)",
    points: "9.01193641 0.114624148 9.01193641 0.596871691 8.70420672 0.891176937 8.70420672 2.19644652 8.35517102 2.57955966 8.35517102 3.80118459 8.33968127 3.80118459 8.33968127 2.57336376 8.68871697 2.19128327 8.68871697 0.884981037 8.99644666 0.590675791 8.99644666 0.114624148"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-71",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-71)",
    points: "7.75933198 6.9476691 8.07738818 6.60999255 8.07738818 4.85965083 9.19265016 3.71134404 9.19265016 3.14545185 8.67322722 2.57852701 8.67322722 0.129081248 8.61023557 0.129081248 8.61023557 2.60227796 9.13069116 3.17023545 9.13069116 3.68552779 8.01542918 4.83486723 8.01542918 6.58520895 7.67362203 6.9476691"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-73",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-72"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-73)",
    points: "8.39750967 6.9373426 6.02344736 6.9373426 6.01312086 6.9476691 8.40886882 6.9476691 8.86736542 6.48813985 8.86736542 5.36255137 7.94933958 4.45072143 7.94933958 2.45873961 8.41919532 2.00127567 8.42126062 1.99921037 8.42126062 0.113591498 8.40577087 0.113591498 8.40577087 1.99198182 7.93591513 2.44944576 7.93384983 2.45151106 7.93384983 4.45691733 8.85187567 5.36977992 8.85187567 6.48194395"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-75",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-75)",
    points: "8.23331833 0.123917998 8.23331833 1.17412303 7.53524694 1.86806382 7.53524694 4.00255134 6.96109354 4.57154148 6.96109354 6.20003051 6.89913455 6.20003051 6.89913455 4.54572523 7.47328794 3.97673509 7.47328794 1.84224757 8.17135933 1.14830678 8.17135933 0.123917998"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-77",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-76"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-77)",
    points: "8.95514066 4.21321194 8.39647702 4.77187558 8.39647702 6.6275476 8.06602903 6.9476691 8.11146563 6.9476691 8.42745652 6.6399394 8.42745652 4.78426738 8.98612016 4.22560374 8.98612016 3.4149735 7.78927883 2.23258927 7.78927883 1.73794992 8.03298423 1.47565683 8.03298423 0.129081248 8.00200473 0.129081248 8.00200473 1.46326503 7.75726668 1.72555812 7.75726668 2.24498107 8.95514066 3.4273653"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-79",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-78"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-79)",
    points: "7.84400928 6.05649216 7.37931679 6.52944585 7.37931679 6.9476691 7.41029629 6.9476691 7.41029629 6.5428703 7.87602143 6.06888396 7.87602143 5.20662122 7.33801079 4.66861058 7.33801079 1.70593777 7.71492803 1.32179198 7.71492803 0.0805466988 7.68394853 0.0805466988 7.68394853 1.30836753 7.30703129 1.69354597 7.30703129 4.68203503 7.84400928 5.21901302"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-81",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-81)",
    points: "7.43507989 0.0981017485 7.43507989 1.12249053 6.87848155 1.65430528 6.87848155 3.01120735 6.8629918 3.01120735 6.8629918 1.64707673 7.41959014 1.11526198 7.41959014 0.0981017485"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-83",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-82"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-83)",
    points: "5.95735776 6.9476691 5.96561896 6.9476691 5.96561896 6.28470781 5.51331827 5.83963566 5.51331827 3.2084435 5.87061516 2.85630986 5.87164781 2.85527721 5.87164781 1.36619593 6.6192864 0.704267289 6.62031905 0.702201989 6.62031905 0.0609263491 6.6130905 0.0609263491 6.6130905 0.699104039 5.86545191 1.36103268 5.86441926 1.36206533 5.86441926 2.85217926 5.50608972 3.2043129 5.50505707 3.20534555 5.50505707 5.84376626 5.95735776 6.28780576"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-85",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-84"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-85)",
    points: "6.7411391 3.68552779 6.05029626 4.33816258 6.04719831 4.34022788 6.04719831 5.71984826 6.6709189 6.3446015 6.6709189 6.9476691 6.6874413 6.9476691 6.6874413 6.33737295 6.06268806 5.71365236 6.06268806 4.34745643 6.75456355 3.69378899 6.7576615 3.69172369 6.7576615 1.43848143 5.96974956 0.65883069 5.96974956 0.0609263491 5.95425981 0.0609263491 5.95425981 0.66502659 6.7411391 1.44570998"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-87",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-86"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-87)",
    points: "7.58791209 5.34086572 7.58791209 5.82621121 7.58068354 5.82621121 7.58068354 5.34396367 7.10463189 4.91541393 7.10463189 3.61220965 6.41791965 2.91000766 6.41791965 0.520455592 6.4189523 0.518390292 6.8402735 0.0505998492 6.84543675 0.0557630992 6.4251482 0.522520892 6.4251482 2.90690971 7.11186044 3.6091117 7.11186044 4.91128333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-89",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-89)",
    points: "5.79006846 4.24832204 7.22545194 5.70745646 7.22545194 6.9476691 7.25643144 6.9476691 7.25643144 5.69506466 5.82104796 4.23593024 5.82104796 3.17436605 5.59489762 2.9874564 5.59489762 1.05743358 5.75082776 0.846772987 5.75082776 0.0846772987 5.71984826 0.0846772987 5.71984826 0.836446487 5.56391812 1.04710708 5.56391812 3.0019135 5.79006846 3.18882315"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-91",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-91)",
    points: "5.52467742 0.0846772987 5.52467742 2.08492032 5.52261212 2.08698562 5.32227802 2.33378896 5.32227802 3.1113744 5.30678827 3.1113744 5.30678827 2.32862571 5.50918767 2.07872442 5.50918767 0.0846772987"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-93",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-93)",
    points: "9.30417636 5.24689457 9.30417636 5.78697051 9.29591516 5.78697051 9.29591516 5.24999252 7.73661368 3.69791959 7.73661368 2.91000766 7.17485209 2.38748676 7.17485209 1.86290057 7.18208064 1.86290057 7.18208064 2.38438881 7.74384223 2.90690971 7.74384223 3.69482164"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-95",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-95)",
    points: "6.9290814 0.521488242 6.9290814 0.862262737 6.63271085 1.15863328 6.63271085 2.78918761 6.15665921 3.22599855 6.15665921 4.13886114 5.67234636 4.61388013 5.67234636 5.06927877 5.61038737 5.06927877 5.61038737 4.58806388 6.09470021 4.11201224 6.09470021 3.19914965 6.5697192 2.76233871 6.5697192 1.13281703 6.86608975 0.836446487 6.86608975 0.521488242"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-97",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-96"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27156436,3.96124534 C9.24414501,3.96124534 9.22156436,3.98382599 9.22156436,4.01124534 C9.22156436,4.0386647 9.24414501,4.06124534 9.27156436,4.06124534 C9.29898372,4.06124534 9.32156436,4.0386647 9.32156436,4.01124534 C9.32156436,3.98382599 9.29898372,3.96124534 9.27156436,3.96124534",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-97)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-99",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31803361,5.76735016 C9.29061426,5.76735016 9.26803361,5.78993081 9.26803361,5.81735016 C9.26803361,5.84476952 9.29061426,5.86735016 9.31803361,5.86735016 C9.34545296,5.86735016 9.36803361,5.84476952 9.36803361,5.81735016 C9.36803361,5.78993081 9.34545296,5.76735016 9.31803361,5.76735016",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-99)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-101",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-100"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64239951,5.05378902 C5.61245267,5.05378902 5.58870172,5.07753997 5.58870172,5.10748682 C5.58870172,5.13743367 5.61245267,5.16118462 5.64239951,5.16118462 C5.67234636,5.16118462 5.69609731,5.13743367 5.69609731,5.10748682 C5.69609731,5.07753997 5.67234636,5.05378902 5.64239951,5.05378902",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-101)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-103",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-102"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93217935,6.17421426 C6.9022325,6.17421426 6.87848155,6.19796521 6.87848155,6.22791206 C6.87848155,6.25785891 6.9022325,6.28160986 6.93217935,6.28160986 C6.96212619,6.28160986 6.98587714,6.25785891 6.98587714,6.22791206 C6.98587714,6.19796521 6.96212619,6.17421426 6.93217935,6.17421426",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-103)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-105",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-104"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.60176934,5.82001531 C7.57434998,5.82001531 7.55176934,5.84259596 7.55176934,5.87001531 C7.55176934,5.89743467 7.57434998,5.92001531 7.60176934,5.92001531 C7.62918869,5.92001531 7.65176934,5.89743467 7.65176934,5.87001531 C7.65176934,5.84098305 7.62918869,5.82001531 7.60176934,5.82001531",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-105)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-107",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-106"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.36489767,3.79602134 C8.33747832,3.79602134 8.31489767,3.81860199 8.31489767,3.84602134 C8.31489767,3.8734407 8.33747832,3.89602134 8.36489767,3.89602134 C8.39231703,3.89602134 8.41489767,3.8734407 8.41489767,3.84602134 C8.41489767,3.81860199 8.39231703,3.79602134 8.36489767,3.79602134",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-107)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-109",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-108"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8902735,3.00501145 C6.86285414,3.00501145 6.8402735,3.0275921 6.8402735,3.05501145 C6.8402735,3.08243081 6.86285414,3.10501145 6.8902735,3.10501145 C6.91769285,3.10501145 6.9402735,3.08243081 6.9402735,3.05501145 C6.9402735,3.0275921 6.91930575,3.00501145 6.8902735,3.00501145",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-109)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-111",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-110"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33303732,3.10621115 C5.30561797,3.10621115 5.28303732,3.1287918 5.28303732,3.15621115 C5.28303732,3.18363051 5.30561797,3.20621115 5.33303732,3.20621115 C5.36045668,3.20621115 5.38303732,3.18363051 5.38303732,3.15621115 C5.38303732,3.1287918 5.36045668,3.10621115 5.33303732,3.10621115",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-111)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.621260, 3.428398)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.135277148,0.754867139 L0.290174646,0.570022791 C0.384145794,0.64230829 0.492574043,0.67122249 0.593773741,0.67122249 C0.64540624,0.67122249 0.66812454,0.65779804 0.66812454,0.63404709 L0.66812454,0.63198179 C0.66812454,0.607198191 0.64127564,0.593773741 0.548337142,0.575186041 C0.353166295,0.535945342 0.182779047,0.480182243 0.182779047,0.296370546 L0.182779047,0.294305246 C0.182779047,0.129081248 0.311860295,0.00206529997 0.551435092,0.00206529997 C0.718724389,0.00206529997 0.842642387,0.0413059994 0.942809436,0.120820048 L0.801336388,0.317023545 C0.719757039,0.257129846 0.621655291,0.231313597 0.541108592,0.231313597 C0.497737292,0.231313597 0.478116943,0.245770696 0.478116943,0.267456346 L0.478116943,0.269521646 C0.478116943,0.293272596 0.501867892,0.307729695 0.593773741,0.325284745 C0.815793488,0.366590744 0.964495085,0.430615044 0.964495085,0.605132891 L0.964495085,0.607198191 C0.964495085,0.789977238 0.814760838,0.901503436 0.581381941,0.901503436 C0.403766144,0.900470786 0.244738046,0.850903587 0.135277148,0.754867139",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40750193,0.0103264998 L1.69561127,0.0103264998 L2.06116937,0.884981037 L1.74517847,0.884981037 L1.69974187,0.768291588 L1.39614278,0.768291588 L1.35173883,0.884981037 L1.04194383,0.884981037 L1.40750193,0.0103264998 Z M1.62745638,0.562794242 L1.54897498,0.351100995 L1.46946093,0.561761592 L1.62745638,0.561761592 L1.62745638,0.562794242 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "2.18921797 0.0165223998 2.91620356 0.0165223998 2.91620356 0.264358396 2.47939261 0.264358396 2.47939261 0.374851944 2.88522406 0.374851944 2.88522406 0.601002291 2.47939261 0.601002291 2.47939261 0.884981037 2.18921797 0.884981037"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "3.07729695 0.0165223998 3.81770699 0.0165223998 3.81770699 0.255064546 3.36230835 0.255064546 3.36230835 0.342839795 3.78672749 0.342839795 3.78672749 0.552467742 3.36230835 0.552467742 3.36230835 0.64643889 3.82390289 0.64643889 3.82390289 0.884981037 3.07729695 0.884981037"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "4.21734254 0.262293096 3.96124534 0.262293096 3.96124534 0.0165223998 4.76258173 0.0165223998 4.76258173 0.262293096 4.50751718 0.262293096 4.50751718 0.884981037 4.21734254 0.884981037"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "5.17873967 0.577251341 4.85138963 0.0165223998 5.17667437 0.0165223998 5.32537597 0.301533795 5.47511022 0.0165223998 5.79626436 0.0165223998 5.46891432 0.573120741 5.46891432 0.884981037 5.17873967 0.884981037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00309794995,3.07729695 L0.356264245,2.74065306 C0.516324992,2.92033416 0.68258164,3.0205012 0.919058486,3.0205012 C1.11216403,3.0205012 1.24847383,2.91104031 1.24847383,2.73755511 L1.24847383,2.73135921 C1.24847383,2.54135161 1.07911923,2.43498866 0.792042538,2.43498866 L0.579316641,2.43498866 L0.499802592,2.10867127 L1.05536828,1.54897498 L0.139407748,1.54897498 L0.139407748,1.10906608 L1.71419897,1.10906608 L1.71419897,1.49527718 L1.12558848,2.05910407 C1.44157938,2.11280187 1.75137437,2.27905852 1.75137437,2.71173886 L1.75137437,2.71793476 C1.75137437,3.15784365 1.43228553,3.48003045 0.912862586,3.48003045 C0.492574043,3.48003045 0.203432047,3.3137738 0.00309794995,3.07729695",
    id: "Path",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11693247,3.23012915 C1.94757787,3.06077455 1.84018227,2.81087326 1.84018227,2.34824606 L1.84018227,2.34205016 C1.84018227,1.62332578 2.16649967,1.07085803 2.86250576,1.07085803 C3.17849665,1.07085803 3.38502665,1.16379653 3.59155665,1.32695523 L3.322035,1.72349282 C3.1692028,1.60680338 3.0452848,1.53658318 2.84598336,1.53658318 C2.55684136,1.53658318 2.41020506,1.76996207 2.37612761,2.07562647 C2.49281706,1.99921037 2.62912686,1.92589222 2.85837516,1.92589222 C3.32100235,1.92589222 3.67726659,2.18198942 3.67726659,2.66836756 L3.67726659,2.67456346 C3.67726659,3.1506151 3.29415345,3.48003045 2.78815496,3.48003045 C2.48662116,3.48003045 2.28009117,3.39328785 2.11693247,3.23012915 M3.1692028,2.69728176 L3.1692028,2.69108586 C3.1692028,2.49488236 3.0163706,2.35134401 2.76337136,2.35134401 C2.51037211,2.35134401 2.36373581,2.49075176 2.36373581,2.68798791 L2.36373581,2.69418381 C2.36373581,2.89038731 2.51656801,3.04012155 2.76956726,3.04012155 C3.0225665,3.04012155 3.1692028,2.89761586 3.1692028,2.69728176",
    id: "Shape",
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83240711,2.26769937 C5.83240711,2.24911167 5.83240711,2.23155662 5.83137446,2.21296892 C5.83137446,2.20677302 5.83137446,2.20160977 5.83034181,2.19541387 C5.82930916,2.18198942 5.82930916,2.16856497 5.82827651,2.15514052 C5.82724386,2.14584667 5.82724386,2.13655282 5.82621121,2.12725897 C5.82517856,2.11589982 5.82414591,2.10557332 5.82311326,2.09421417 C5.82208061,2.08388767 5.82104796,2.07252852 5.81898266,2.06220202 C5.81898266,2.05910407 5.81795001,2.05497347 5.81795001,2.05187552 C5.74050126,1.48391803 5.35532282,1.06879273 4.80078978,1.06879273 C4.28549744,1.06879273 3.91167814,1.43228553 3.79808664,1.94138197 C3.79705399,1.94447992 3.79705399,1.94654522 3.79602134,1.94964317 C3.79395604,1.96100232 3.79085809,1.97236147 3.78879279,1.98372062 C3.78776014,1.98991652 3.78672749,1.99611242 3.78569484,2.00230832 C3.78259689,2.01676542 3.78053159,2.03225517 3.77846629,2.04671227 C3.77743364,2.05703877 3.77536834,2.06633262 3.77433569,2.07665912 C3.77330304,2.08388767 3.77227039,2.09111622 3.77123774,2.09834477 C3.76917244,2.11486717 3.76813979,2.13035692 3.76607449,2.14687932 C3.76607449,2.14997727 3.76607449,2.15307522 3.76504184,2.15617317 C3.76400919,2.17166292 3.76297654,2.18715267 3.76194389,2.20367507 C3.76194389,2.20883832 3.76194389,2.21400157 3.76091124,2.21916482 C3.75987859,2.23775252 3.75987859,2.25634022 3.75987859,2.27492792 L3.75987859,2.27492792 L3.75987859,2.28112382 L3.75987859,2.28112382 C3.75987859,2.28112382 3.75987859,2.28112382 3.75987859,2.28112382 C3.75987859,2.29971152 3.75987859,2.31726657 3.76091124,2.33585426 C3.76091124,2.34205016 3.76091124,2.34721341 3.76194389,2.35340931 C3.76297654,2.36683376 3.76297654,2.38025821 3.76400919,2.39368266 C3.76504184,2.40297651 3.76504184,2.41227036 3.76607449,2.42156421 C3.76710714,2.43292336 3.76813979,2.44324986 3.76917244,2.45460901 C3.77020509,2.46493551 3.77123774,2.47629466 3.77330304,2.48662116 C3.77330304,2.49075176 3.77433569,2.49384971 3.77433569,2.49694766 C3.85178444,3.06490515 4.23696289,3.48003045 4.79149593,3.48003045 C5.30678827,3.48003045 5.68060756,3.11653765 5.79419906,2.60744121 C5.79523171,2.60434326 5.79523171,2.60227796 5.79626436,2.59918001 C5.79832966,2.58782086 5.80142761,2.57646171 5.80349291,2.56510256 C5.80452556,2.55890666 5.80555821,2.55271076 5.80659086,2.54651486 C5.80968881,2.53205776 5.81175411,2.51656801 5.81381941,2.50211091 C5.81485206,2.49178441 5.81691736,2.48249056 5.81795001,2.47216406 C5.81898266,2.46493551 5.82001531,2.45770696 5.82104796,2.45047841 C5.82311326,2.43395601 5.82414591,2.41846626 5.82621121,2.40194386 C5.82621121,2.39884591 5.82621121,2.39574796 5.82724386,2.39265001 C5.82827651,2.37716026 5.82930916,2.36167051 5.83034181,2.34514811 C5.83034181,2.33998486 5.83034181,2.33482161 5.83137446,2.32965836 C5.83240711,2.31107067 5.83240711,2.29248297 5.83240711,2.27389527 L5.83240711,2.27389527 L5.83240711,2.26769937 L5.83240711,2.26769937 L5.83240711,2.26769937 Z M4.80078978,3.01740325 C4.65621878,3.01740325 4.53436608,2.94821571 4.44659083,2.83152626 C4.44659083,2.83152626 4.44762348,2.83049361 4.44762348,2.83049361 C4.35365233,2.70554296 4.29685659,2.52689451 4.28859539,2.32139716 C4.28859539,2.32036451 4.28859539,2.31829922 4.28859539,2.31726657 C4.28859539,2.30384212 4.28756274,2.29041767 4.28756274,2.27699322 C4.28756274,2.27699322 4.28756274,2.27699322 4.28756274,2.27596057 L4.28756274,2.26976467 C4.28756274,2.25634022 4.28756274,2.24188312 4.28859539,2.22845867 C4.28859539,2.22432807 4.28859539,2.22123012 4.28859539,2.21709952 C4.28859539,2.20780567 4.28962804,2.19747917 4.28962804,2.18818532 C4.28962804,2.18405472 4.29066069,2.17992412 4.29066069,2.17579352 C4.29169334,2.16649967 4.29169334,2.15823847 4.29272599,2.14894462 C4.29272599,2.14481402 4.29375864,2.14068342 4.29375864,2.13655282 C4.29479129,2.12725897 4.29582394,2.11899777 4.29685659,2.10970392 C4.29685659,2.10557332 4.29788924,2.10247537 4.29788924,2.09834477 C4.29892189,2.08905092 4.30098719,2.07975707 4.30201984,2.07046322 C4.30201984,2.06736527 4.30305249,2.06426732 4.30408514,2.06116937 C4.30615044,2.05187552 4.30718309,2.04154902 4.30924838,2.03225517 C4.30924838,2.03018987 4.31028103,2.02812457 4.31028103,2.02605927 C4.31234633,2.01573277 4.31441163,2.00540627 4.31750958,1.99507977 C4.31750958,1.99404712 4.31750958,1.99301447 4.31854223,1.99198182 C4.34539113,1.88458622 4.38669713,1.79164772 4.44246023,1.71729692 C4.44246023,1.71729692 4.44246023,1.71729692 4.44246023,1.71729692 C4.52920283,1.60164013 4.64899023,1.53348523 4.79356123,1.53348523 C4.93813223,1.53348523 5.05998492,1.60267278 5.14776017,1.71936222 C5.14776017,1.71936222 5.14672752,1.72039487 5.14672752,1.72039487 C5.24069867,1.84534552 5.29852707,2.02399397 5.30575562,2.22949132 C5.30575562,2.23052397 5.30575562,2.23258927 5.30575562,2.23362192 C5.30575562,2.24704637 5.30678827,2.26047082 5.30678827,2.27389527 L5.30678827,2.27492792 L5.30678827,2.28112382 C5.30678827,2.29454827 5.30678827,2.30900537 5.30575562,2.32242981 C5.30575562,2.32656041 5.30575562,2.32965836 5.30575562,2.33378896 C5.30575562,2.34308281 5.30472297,2.35340931 5.30472297,2.36270316 C5.30472297,2.36683376 5.30369032,2.37096436 5.30369032,2.37509496 C5.30265767,2.38438881 5.30265767,2.39265001 5.30162502,2.40194386 C5.30162502,2.40607446 5.30059237,2.41020506 5.30059237,2.41433566 C5.29955972,2.42362951 5.29852707,2.43189071 5.29749442,2.44118456 C5.29749442,2.44531516 5.29646177,2.44841311 5.29646177,2.45254371 C5.29542912,2.46183756 5.29336382,2.47113141 5.29233117,2.48042526 C5.29233117,2.48352321 5.29129852,2.48662116 5.29026587,2.48971911 C5.28820057,2.49901296 5.28716792,2.50933946 5.28510262,2.51863331 C5.28510262,2.52069861 5.28406997,2.52276391 5.28406997,2.52482921 C5.28200467,2.53515571 5.27993937,2.54548221 5.27684142,2.55580871 C5.27684142,2.55684136 5.27580877,2.55787401 5.27580877,2.55890666 C5.24999252,2.66630226 5.20765387,2.75924076 5.15189077,2.83359156 C5.15189077,2.83359156 5.15189077,2.83359156 5.15189077,2.83359156 C5.06411552,2.94924836 4.94536078,3.01740325 4.80078978,3.01740325 M4.79872448,2.60124531 C4.73470018,2.60124531 4.68203503,2.57129846 4.64279433,2.51966596 C4.64279433,2.51966596 4.64279433,2.51966596 4.64382698,2.51966596 C4.60252098,2.46493551 4.57773738,2.38645411 4.57463943,2.29558092 C4.57463943,2.29454827 4.57463943,2.29454827 4.57463943,2.29351562 C4.57463943,2.28731972 4.57463943,2.28112382 4.57463943,2.27596057 C4.57463943,2.27596057 4.57463943,2.27596057 4.57463943,2.27596057 L4.57463943,2.27182997 C4.57463943,2.26563407 4.57463943,2.25943817 4.57463943,2.25427492 C4.57463943,2.25220962 4.57463943,2.25117697 4.57463943,2.24911167 C4.57463943,2.24498107 4.57463943,2.24085047 4.57567208,2.23671987 C4.57567208,2.23465457 4.57567208,2.23258927 4.57567208,2.23155662 C4.57567208,2.22742602 4.57670473,2.22329542 4.57670473,2.22019747 C4.57670473,2.21813217 4.57670473,2.21606687 4.57773738,2.21503422 C4.57773738,2.21090362 4.57877003,2.20677302 4.57877003,2.20367507 C4.57877003,2.20160977 4.57877003,2.20057712 4.57980268,2.19851182 C4.58083533,2.19438122 4.58083533,2.19025062 4.58186798,2.18612002 C4.58186798,2.18508737 4.58186798,2.18302207 4.58290063,2.18198942 C4.58393328,2.17785882 4.58393328,2.17372822 4.58496593,2.16959762 C4.58496593,2.16856497 4.58496593,2.16753232 4.58599858,2.16649967 C4.58703123,2.16236907 4.58806388,2.15720582 4.58909653,2.15307522 C4.58909653,2.15307522 4.58909653,2.15204257 4.58909653,2.15204257 C4.60045568,2.10454067 4.61904338,2.06426732 4.64382698,2.03122252 C4.64382698,2.03122252 4.64382698,2.03122252 4.64382698,2.03122252 C4.68203503,1.98062267 4.73470018,1.95067582 4.79769183,1.95067582 C4.86171613,1.95067582 4.91438128,1.98062267 4.95362198,2.03225517 C4.95362198,2.03225517 4.95362198,2.03225517 4.95258933,2.03225517 C4.99389532,2.08698562 5.01867892,2.16546702 5.02177687,2.25634022 C5.02177687,2.25737287 5.02177687,2.25737287 5.02177687,2.25840552 C5.02177687,2.26460142 5.02177687,2.27079732 5.02177687,2.27596057 L5.02177687,2.27596057 L5.02177687,2.27905852 C5.02177687,2.28525442 5.02177687,2.29145032 5.02177687,2.29661357 C5.02177687,2.29867887 5.02177687,2.29971152 5.02177687,2.30177682 C5.02177687,2.30590742 5.02177687,2.31003802 5.02074422,2.31416862 C5.02074422,2.31623392 5.02074422,2.31829922 5.02074422,2.31933187 C5.02074422,2.32346246 5.01971157,2.32759306 5.01971157,2.33069101 C5.01971157,2.33275631 5.01971157,2.33378896 5.01867892,2.33585426 C5.01867892,2.33998486 5.01764627,2.34411546 5.01764627,2.34721341 C5.01764627,2.34927871 5.01764627,2.35031136 5.01661362,2.35237666 C5.01558097,2.35650726 5.01558097,2.36063786 5.01454832,2.36476846 C5.01454832,2.36580111 5.01454832,2.36786641 5.01351567,2.36889906 C5.01248302,2.37302966 5.01248302,2.37716026 5.01145037,2.38129086 C5.01145037,2.38232351 5.01145037,2.38335616 5.01041772,2.38438881 C5.00938507,2.38851941 5.00835242,2.39368266 5.00731977,2.39781326 C5.00731977,2.39781326 5.00731977,2.39884591 5.00731977,2.39884591 C4.99596062,2.44634781 4.97737292,2.48662116 4.95258933,2.51966596 C4.95258933,2.51966596 4.95258933,2.51966596 4.95258933,2.51966596 C4.91438128,2.57129846 4.86171613,2.60124531 4.79872448,2.60124531",
    id: "Shape",
    fill: "#FFD400"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety360);
export default __webpack_public_path__ + "static/media/safety-360.d8c8fe0371e7dcf89c06c1b0fb2d928c.svg";
export { ForwardRef as ReactComponent };